import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=7638a1a4&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./Login.scss?vue&type=style&index=0&id=7638a1a4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638a1a4",
  null
  
)

export default component.exports